// @ts-ignore
import { BTooltip } from 'buefy/dist/esm/tooltip';
import { defineComponent, h, SetupContext, VNodeChildren } from 'vue';

export type TooltipPositions = 'is-top' | 'is-right' | 'is-bottom' | 'is-left';

export type TooltipSizes = 'is-small' | 'is-medium' | 'is-large';

interface TooltipProps {
  label: string;
  position?: TooltipPositions;
  multilined?: boolean;
  classes?: string;
  size?: TooltipSizes;
  appendToBody?: boolean;
  active?: boolean;
}

export const Tooltip = defineComponent<TooltipProps>({
  name: 'Tooltip',
  props: ['label', 'position', 'multilined', 'classes', 'size', 'appendToBody', 'active'],
  setup(props, context: SetupContext) {
    return function render() {
      return h(
        BTooltip,
        {
          class: props.classes,
          props: {
            label: props.label,
            position: props.position,
            multilined: props.multilined ?? false,
            size: props.size ?? 'is-medium',
            appendToBody: props.appendToBody ?? false,
            active: props.active ?? true,
          },
        },
        [
          context.slots.default?.(),
          context.slots.content && h('template', { slot: 'content' }, context.slots.content()),
        ],
      );
    };
  },
});

export const tooltip = (props: TooltipProps, contents: VNodeChildren | string, slot = 'default') => h(Tooltip, {
  props,
  slot,
}, contents);
